import { showSpinner, hideSpinner } from '/source/_patterns/01-components/spinner/spinner';
import * as subscriptionService from '/source/js/services/subscriptionService';

let subscriptionWidget;
let localSubscriptionDefaultState;
let nfrSubscriptionDefaultState;
let localSubscriptionManageState;
let nfrSubscriptionManageState;
let localSubscriptionActiveState;
let nfrSubscriptionActiveState;
let hasBothMarkets;
let $toggleLocal;
let $toggleNfr;
let trueValue = 'True';
let localDivDateUpdate;
let localSuccessDateUpdate;
let localCancelDateUpdate;
let localConfirmDateUpdate;
let nfrDivDateUpdate;
let nfrSuccessDateUpdate;
let nfrCancelDateUpdate;
let nfrConfirmDateUpdate;
let localNextSubscriptionDate;
let nfrNextSubscriptionDate;
let nfrErrorDateUpdate;
let localErrorDateUpdate;

function initEventHandlers() {
    subscriptionWidget = $('#subscription-widget-main');
    localSubscriptionDefaultState = $('#local-subscription-default-state');
    nfrSubscriptionDefaultState = $('#nrf-subscription-default-state');
    localSubscriptionActiveState = $('#local-subscription-active-state');
    nfrSubscriptionActiveState = $('#nrf-subscription-active-state');
    localSubscriptionManageState = $('#local-subscription-manage-state');
    nfrSubscriptionManageState = $('#nrf-subscription-manage-state');
    localDivDateUpdate = $('#local-div-date-update');
    localSuccessDateUpdate = $('#local-success-date-update');
    localCancelDateUpdate = $('#local-cancel-date-update');
    localConfirmDateUpdate = $('#local-confirm-date-update');
    nfrDivDateUpdate = $('#nfr-div-date-update');
    nfrSuccessDateUpdate = $('#nfr-success-date-update');
    nfrCancelDateUpdate = $('#nfr-cancel-date-update');
    nfrConfirmDateUpdate = $('#nfr-confirm-date-update');
    localNextSubscriptionDate = new Date($('#hdn-local-next-subscription-date').val());
    nfrNextSubscriptionDate = new Date($('#hdn-nfr-next-subscription-date').val());
    nfrErrorDateUpdate = $('#nfr-error-date-update');
    localErrorDateUpdate = $('#local-error-date-update');

    $toggleLocal = $('#toggle-otg');
    $toggleNfr = $('#toggle-nfr');
    $toggleLocal.on('change', localChange);
    $toggleNfr.on('change', nfrChange);

    localCancelDateUpdate.on('click', localDateUpdateCancel);
    nfrCancelDateUpdate.on('click', nfrDateUpdateCancel);
    localConfirmDateUpdate.on('click', localDateUpdateConfirm);
    nfrConfirmDateUpdate.on('click', nfrDateUpdateConfirm);

    hasBothMarkets = $(subscriptionWidget).attr('data-has-both-markets');
    let selectNfrOnLoad = $(subscriptionWidget).attr('data-select-nfr');
    if(hasBothMarkets === trueValue) {
        if(selectNfrOnLoad === trueValue) {
            enableProperNfrState();
        } else {
            enableProperLocalState();
        }
    } else {
        enableProperLocalState();
    }
}

function localChange() {
    $($toggleNfr).attr('checked', false);
    $($toggleLocal).attr('checked', true);
    $($toggleLocal).val('true');
    enableProperLocalState();
}

function resetAllStates() {
    $(localSubscriptionActiveState).addClass('d-none');
    $(localSubscriptionManageState).addClass('d-none');
    $(localSubscriptionDefaultState).addClass('d-none');
    $(nfrSubscriptionActiveState).addClass('d-none');
    $(nfrSubscriptionManageState).addClass('d-none');
    $(nfrSubscriptionDefaultState).addClass('d-none');
}

function nfrChange() {
    $($toggleLocal).attr('checked', false);
    $($toggleNfr).attr('checked', true);
    $($toggleNfr).val('true');
    enableProperNfrState();
}

function enableProperLocalState() {
    resetAllStates();
    let isLocalInCart = $(subscriptionWidget).attr('data-local');
    let isLocalInManageState = $(subscriptionWidget).attr('data-local-manage');
    if(isLocalInManageState === trueValue) {
        $(localSubscriptionManageState).removeClass('d-none');
    } else if(isLocalInCart === trueValue) {
        $(localSubscriptionActiveState).removeClass('d-none');
    } else {
        $(localSubscriptionDefaultState).removeClass('d-none');
    }
}

function enableProperNfrState() {
    resetAllStates();
    if(hasBothMarkets === trueValue) {
        let isNfrInCart = $(subscriptionWidget).attr('data-nfr');
        let isNfrInManageState = $(subscriptionWidget).attr('data-nfr-manage');
        if(isNfrInManageState === trueValue) {
            $(nfrSubscriptionManageState).removeClass('d-none');
        } else if(isNfrInCart === trueValue) {
            $(nfrSubscriptionActiveState).removeClass('d-none');
        } else {
            $(nfrSubscriptionDefaultState).removeClass('d-none');
        }
    }
}

function initDatePicker() {
    let localDatePicker = $('#local-subscription-datepicker');
    let nfrDatePicker = $('#nfr-subscription-datepicker');
    let localStartDate = $(localDatePicker).data('start-date');
    let localEndDate = $(localDatePicker).data('end-date');
    let nfrStartDate = $(nfrDatePicker).data('start-date');
    let nfrEndDate = $(nfrDatePicker).data('end-date');
    localDatePicker.datepicker({
        format: 'yy-mm-dd', // format for date
        setDate: localNextSubscriptionDate,
        startDate: new Date(localStartDate), // start date starts the next day
        endDate: new Date(localEndDate),
        onSelect: function (date) {
            if(localDivDateUpdate.hasClass('d-none')) {
                localDivDateUpdate.removeClass('d-none');
            }
            if(!localSuccessDateUpdate.hasClass('d-none')) {
                localSuccessDateUpdate.addClass('d-none');
            }
            if(!localErrorDateUpdate.hasClass('d-none')) {
                localErrorDateUpdate.addClass('d-none');
            }
        }
    });
    nfrDatePicker.datepicker({
        format: 'yy-mm-dd', // format for date
        setDate: nfrNextSubscriptionDate,
        startDate: new Date(nfrStartDate), // start date starts the next day
        endDate: new Date(nfrEndDate),
        onSelect: function (date) {
            if(nfrDivDateUpdate.hasClass('d-none')) {
                nfrDivDateUpdate.removeClass('d-none');
            }
            if(!nfrSuccessDateUpdate.hasClass('d-none')) {
                nfrSuccessDateUpdate.addClass('d-none');
            }
            if(!nfrErrorDateUpdate.hasClass('d-none')) {
                nfrErrorDateUpdate.addClass('d-none');
            }
        }
    });
}

function localDateUpdateCancel() {
    $('#local-subscription-datepicker').val(localNextSubscriptionDate);
    localDivDateUpdate.addClass('d-none');
}

async function localDateUpdateConfirm() {
    showSpinner('updating local subscription date started');
    let response;
    try {
        response = await subscriptionService.updateNextOrderDate($('#local-subscription-datepicker').val());
    } catch (ex) {
        console.log('Unexpected error', ex);
    }
    hideSpinner('updating local subscription date completed');
    if(response && response.IsSuccessful) {
        localDivDateUpdate.addClass('d-none');
        localSuccessDateUpdate.removeClass('d-none');
        if(!localErrorDateUpdate.hasClass('d-none')) {
            localErrorDateUpdate.addClass('d-none');
        }
    } else {
        localDivDateUpdate.addClass('d-none');
        localErrorDateUpdate.removeClass('d-none');
        if(!localSuccessDateUpdate.hasClass('d-none')) {
            localSuccessDateUpdate.addClass('d-none');
        }
    }
}

function nfrDateUpdateCancel() {
    $('#nfr-subscription-datepicker').val(nfrNextSubscriptionDate);
    nfrDivDateUpdate.addClass('d-none');
}

async function nfrDateUpdateConfirm() {
    showSpinner('updating NFR subscription date started');
    let response;
    try {
        response = await subscriptionService.updateNextOrderDate($('#nfr-subscription-datepicker').val());
    } catch (ex) {
        console.log('Unexpected error', ex);
    }
    hideSpinner('updating NFR subscription date completed');
    if(response && response.IsSuccessful) {
        nfrDivDateUpdate.addClass('d-none');
        nfrSuccessDateUpdate.removeClass('d-none');
        if(!nfrErrorDateUpdate.hasClass('d-none')) {
            nfrErrorDateUpdate.addClass('d-none');
        }
    } else {
        nfrDivDateUpdate.addClass('d-none');
        nfrErrorDateUpdate.removeClass('d-none');
        if(!nfrSuccessDateUpdate.hasClass('d-none')) {
            nfrSuccessDateUpdate.addClass('d-none');
        }
    }
}

$(function () {
    initEventHandlers();
    initDatePicker();
});
